module.exports = __webpack_public_path__ + "img/6.77aac23c.jpg";